import React from 'react';
import Spinner from "../../common/spinner";
import { formatPhoneNumber } from "../../../helpers/formatting";

export default class OrderRefillReview extends React.Component {
    constructor(props) {
        super(props);
    }

    onGoNext() {
        if (this.props.onSubmit) {
            this.props.onSubmit();
        }
    }

    render() {
        const { pickupDayName, pickupTime, pharmacyDetails, rxList, waiting, addressUrl } = this.props;

        if (!pickupTime || !pharmacyDetails || !rxList || !rxList.length) return null;  
        
        const phoneNumber = formatPhoneNumber(pharmacyDetails.PhoneNumber);

        return (
            <div style={this.props.style} className="row review-submission-container">
                <div className="col-12">
                    <h2 className="step-heading">Confirm the details and you’ll be good to go.</h2>
                </div>
                <div className="col-12 review-details-container review-one-col">
                    <div className="row">
                        <div className="col-12">
                            <h2 className="h5">Pickup Time:</h2>
                            <div className="review-details">
                                {pickupDayName} at {pickupTime}
                            </div>
                            <div className="review-edit-btn">
                                <button type="button" className="btn btn-icon-only" onClick={() => this.props.goBack(1)}><span className="icon-edit" /></button>
                            </div>
                            <div className="hr-divider" />
                        </div>

                        <div className="col-12">
                            <h2 className="h5">Prescriptions:</h2>
                            <div className="review-details">
                                {rxList.map(item => <div key={item.RxNumber}>{item.DrugName}</div>)}
                            </div>
                            <div className="review-edit-btn">
                                <button type="button" className="btn btn-icon-only" onClick={() => this.props.goBack(0)}><span className="icon-edit" /></button>
                            </div>
                            <div className="hr-divider" />
                        </div>

                        <div className="col-12">
                            <h2 className="h5">Pickup Location:</h2>
                            <div className="review-details">
                                {pharmacyDetails.Name
                                    ? <div>{pharmacyDetails.Name}</div>
                                    : <div className="no-data-dash"><div /></div>
                                }
                                {pharmacyDetails.Address
                                    ? <a href={addressUrl} target="_blank" className="directions-link">
                                        {pharmacyDetails.Address.StreetAddress} {pharmacyDetails.Address.City}{", "}
                                        {pharmacyDetails.Address.State} {pharmacyDetails.Address.Zip}
                                    </a>
                                    : <div className="no-data-dash"><div /></div>
                                }
                                {phoneNumber
                                    ? <div><a className="phone-link" href={"tel:" + phoneNumber}>{phoneNumber}</a></div>
                                    : <div className="no-data-dash"><div /></div>
                                }            
                            </div>

                            <div className="hr-divider" />
                        </div>
                    </div>
                </div> 
                {waiting && <div className="col-12"><Spinner /></div>}
            </div>

        );
    }
}